export const state = () => ({
    title: false,
    description: false,
    variables: {},
    meta: {},
})

export const mutations = {
    setData(state, data) {
        // console.log('seo', data);
        //console.log('seo', _.get(data, 'title'));
        state.title = _.get(data, 'title')
        state.description = _.get(data, 'description')
        state.meta = data
    },  
    setVariables(state, variables) {
        state.variables = variables
    },
}
